import React, { useEffect, useState } from 'react';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import useWindowResize from 'src/hooks/useWindowResize';
import Image from '../../elements/image/image';
import Heading from '../../elements/typography/heading';
import Paragraph from '../../elements/typography/paragraph';
import { FeatureListEntryContainer, FeatureListEntryContainerProps, FeatureListEntryImage, FeatureListEntryTextBlock } from './featureList.entry.styles';
import formatParagraph from 'src/functions/formatParagraph'

export interface FeatureListEntryProps extends FeatureListEntryContainerProps {
  title: string;
  description: string;
  image: { gatsbyImageData: IGatsbyImageData };
  mobileImage?: { gatsbyImageData: IGatsbyImageData };
}

const FeatureListEntry = ({
  textOrientation,
  title,
  description,
  image,
  mobileImage
}: FeatureListEntryProps): JSX.Element => {
  const { width: windowWidth } = useWindowResize();
  const [ featureImage, setFeatureImage ] = useState<IGatsbyImageData>(image.gatsbyImageData)

  useEffect(() => {
    if (mobileImage) {
      if (windowWidth <= 800) {
        setFeatureImage(mobileImage.gatsbyImageData);
      } else {
        setFeatureImage(image.gatsbyImageData);
      }
    }
  }, [ windowWidth, mobileImage ])

  return (
    <FeatureListEntryContainer textOrientation={textOrientation}>
      <FeatureListEntryImage>
        <Image childImageSharp={featureImage} alt={title} />
      </FeatureListEntryImage>

      <FeatureListEntryTextBlock textOrientation={textOrientation}>
        <Heading size="2.75em" sizeLg="2.25em" sizeMd="1.5em" sizeSubMd="2.25em" sizeXs="1.5em" text={title} />
        <Paragraph size="1.625em" sizeLg="1.275em" weight="light">
          {formatParagraph(description)}
        </Paragraph>
      </FeatureListEntryTextBlock>
    </FeatureListEntryContainer>
  )
}

export default FeatureListEntry;
